const EMAIL_IN_ANGLE_BRACKETS = /<([^>\s]+@[^>\s]+)>/;

export const extractEmailAddress = (raw?: string | null): string => {
  if (!raw?.trim()) return "";
  const trimmed = raw.trim();
  const bracketMatch = trimmed.match(EMAIL_IN_ANGLE_BRACKETS);
  if (bracketMatch?.[1]) return bracketMatch[1].trim().toLowerCase();
  if (trimmed.includes("@")) return trimmed.toLowerCase();
  return "";
};

export const isXgsiEmailDomain = (email: string): boolean => {
  const domain = email.split("@")[1]?.toLowerCase();
  return domain === "xgsi.com";
};

/** Use inbound sender when AI did not extract shipper email (skip @xgsi.com). */
export const resolveShipperEmailFallback = (
  aiEmail: string | undefined,
  senderEmail?: string
): string => {
  if (aiEmail?.trim()) return aiEmail.trim();
  const fromEmail = extractEmailAddress(senderEmail);
  if (!fromEmail || isXgsiEmailDomain(fromEmail)) return "";
  return fromEmail;
};
